import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { StateHelper } from 'helpers'
import API from 'API'

const EXCLUDED_TYPES = ['UUID', 'JSON', 'OBJECT']

class DynamicFilterField extends Component {
  constructor (props) {
    super(props)
    this.state = {
      fields: [],
      options: []
    }
    this.driver = null
    if (this.props.attributes) this.driver = this.props.deepstream.record.getRecord('attributes/' + this.props.attributes)
  }

  async componentDidMount () {
    await this.getSchemaFields()
    await this.getAttributeFields()
    await this.getMemory()
    this.props.callback(this.state.fields)
  }

  async getAttributeFields () {
    return new Promise((resolve, reject) => {
      if (!this.props.attributes) return resolve()
      if (!this.driver) return resolve()
      this.driver.whenReady(async record => {
        var attributes = record.get('attributes') || {}
        Object.keys(attributes).map(key => {
          var attribute = attributes[key]
          this.state.options.push({
            key: '.attributes->>' + key,
            name: (typeof this.props.basepath !== 'undefined' ? `${this.props.basepath}.attributes->>${key}` : `attributes->>${key}`),
            title: attribute.name || key, type: 'attribute' })
          })
        this.forceUpdate()
        resolve()
      })
    })
  }
  async getMemory () {
    return new Promise((resolve, reject) => {
      if (this.props.memory.fields.length) {
        this.props.memory.fields.map(field => {
          if (this.state.options.filter(opt => opt.name === field.key).length === 0) return
          this.state.fields.push({ name: field.key, key: field.key, value: field.value, operator: field.operator })
        })
        resolve()
      } else {
        resolve()
      }
    })
  }
  async getSchemaFields () {
    return new Promise(async (resolve, reject) => {
      var fields = await API.list(this.props.schema)
      if (!fields.success) return
      fields = Object.values(fields.data.filter(model => model.name === this.props.model)[0].fields)
      fields = fields.filter(field => !EXCLUDED_TYPES.includes(field.type))
      fields = fields.map(field => {
        field.key = field.name
        if (field.title) return field
        field.title = field.name
        return field
      })
      this.setState({ options: [...this.state.options, ...fields] }, e => {
        this.forceUpdate()
        resolve()
      })
    })
  }
  componentWillReceiveProps (nextProps) {
    if (JSON.stringify(nextProps.memory.fields) === JSON.stringify(this.props.memory.fields)) return
    if (nextProps.loads === this.props.loads) return
    if (nextProps.memory.fields.length) {
      this.setState({
        fields: nextProps.memory.fields.map(field => {
          // eslint-disable-next-line
          if (this.state.options.filter(opt => opt.name == field.key).length === 0) return
          return { name: field.name, key: field.key, value: field.value, operator: field.operator }
        })
      }, e => this.props.callback(this.state.fields))
    }
  }
  getDatatypeOperators (name) {
    var type = this.state.options.filter(opt => (opt.name === name))[0].type || ''
    var operators = []
    switch (type) {
      case 'FLOAT':
      case 'SHORT':
      case 'LONG':
      case 'INT':
      case 'TIMESTAMP':
        operators = [{ name: 'EQUAL' }, { name: 'NOTEQUAL' }, { name: 'GREATER' }, { name: 'LESSER' }, { name: 'GREATEROREQUAL' }, { name: 'LESSEROREQUAL' }, { name: 'ISNULL' }, { name: 'NOTNULL' }]
        break
      case 'STRING':
        operators = [{ name: 'EQUAL' }, { name: 'NOTEQUAL' }, { name: 'IN' }, { name: 'CONTAINS' }, { name: 'STARTSWITH' }, { name: 'ENDSWITH' }, { name: 'ISNULL' }, { name: 'NOTNULL' }, { name: 'ISEMPTY' }, { name: 'ISNOTEMPTY' }]
        break
      case 'BOOLEAN':
        operators = [{ name: 'EQUAL' }, { name: 'NOTEQUAL' }, { name: 'ISNULL' }, { name: 'NOTNULL' }]
        break
      default:
        operators = [{ name: 'EQUAL' }, { name: 'NOTEQUAL' }, { name: 'IN' }, { name: 'CONTAINS' }, { name: 'STARTSWITH' }, { name: 'ENDSWITH' }, { name: 'GREATER' }, { name: 'LESSER' }, { name: 'GREATEROREQUAL' }, { name: 'LESSEROREQUAL' }, { name: 'ISNULL' }, { name: 'NOTNULL' }, { name: 'ISEMPTY' }, { name: 'ISNOTEMPTY' }]
    }
    return operators
  }
  addField (field) {
    this.setState({ fields: [...this.state.fields, { key: field.name, name: field.name, operator: field.type === 'STRING' ? 'CONTAINS' : '' }] })
  }

  removeField (field, index) {
    this.state.fields.splice(index, 1)
    this.forceUpdate()
    this.props.callback(this.state.fields)
  }

  filter (field, index, value) {
    StateHelper.setValueAtPath(this, 'fields.' + index + '.value', value)
    this.props.callback(this.state.fields)
  }

  changeOperator (index, operator) {
    StateHelper.setValueAtPath(this, 'fields.' + index + '.operator', operator)
    this.props.callback(this.state.fields)
  }

  render () {
    return (
      <div>
        <div key={this.props.filter.name} className='row'>
          <div className='col-md-2 col-sm-4'>
            <span className='filter-name'>Add field</span>
          </div>
          <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
            <Select
              options={this.state.options.sort((a, b) => a.name.localeCompare(b.name))}
              labelKey='title'
              valueKey='name'
              className='filter-select'
              value={null}
              onChange={e => this.addField(e)}
            />
          </div>
        </div>
        {this.state.fields.map((field, i) => <div key={field.name + i} className='row' style={{ borderLeft: '3px solid #66a2ed' }}>
          <div className='col-md-2 col-sm-4'>
            <span className='filter-name'><a className='table-link' onClick={e => this.removeField(field, i)}><i className='fa fa-remove' /></a>{this.state.options.filter(opt => opt.name === field.key)[0].title || field.name}</span>
          </div>
          <div className='col-md-4 col-sm-4 flexbox-absolute-center'>
            <Select
              clearable={false}
              options={this.getDatatypeOperators(this.state.fields[i].key)}
              labelKey='name'
              valueKey='name'
              className='filter-select'
              value={this.state.fields[i].operator}
              onChange={e => this.changeOperator(i, e.name)}
            />
          </div>
          <div className='col-md-6 col-sm-4 flexbox-absolute-center'>
            <input value={this.state.fields[i].value} placeholder='Search...' type='text' className='form-control' onKeyUp={e => this.filter(field, i, e.target.value)} onChange={e => this.filter(field, i, e.target.value)} />
          </div>
        </div>)}
      </div>
    )
  }
}
DynamicFilterField = connect(state => state.siteReducer)(DynamicFilterField)
export default DynamicFilterField



// WEBPACK FOOTER //
// ./src/components/basic/misc/DynamicFilterField.js